// extracted by mini-css-extract-plugin
module.exports = {"background":"copyrights-module--background--F0h_L","centrer":"copyrights-module--centrer--BJ6zG"};